import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'lib-canvas-select-tool',
  standalone: true,
  template: `
    <button
      type="button"
      class="cv-tb__btn"
      [class.cv-tb__btn--active]="active"
      (click)="select.emit()"
      title="Select — exit drawing mode"
      aria-label="Select tool"
    >
      <!-- Mouse-cursor / pointer arrow icon -->
      <svg class="cv-toolbar-icon-img" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M4 4l7.07 17 2.51-7.39L21 11.07z"/>
      </svg>
    </button>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class SelectToolComponent {
  @Input() active = false;
  @Output() select = new EventEmitter<void>();
}
